<template>
  <div class="productActions">
    <div
      v-if="showComparision"
      :class="[
        'productActions__action',
        { 'productActions__action--showMobile': showMobileComparision },
      ]"
    >
      <span class="icon-comparison" />
    </div>
    <div v-if="showList" class="productActions__action productActions__action--list">
      <button
        @click="toggleProductFromList({ product, isOnList })"
        :class="['productActions__iconList', { active: isOnList }]"
      />
    </div>
  </div>
</template>

<script>
import listMixin from '~/mixins/list.js';

export default {
  name: 'ProductActions',
  mixins: [listMixin],
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    isOnList: {
      type: Boolean,
      default: false,
    },
    showComparision: {
      type: Boolean,
      default: false,
    },
    showList: {
      type: Boolean,
      default: true,
    },
    showMobileComparision: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.productActions {
  $root: &;
  position: relative;
  z-index: 3;
  display: flex;
  margin-right: -0.9rem;
  margin-left: -0.9rem;
  margin-top: -0.9rem;

  &__action {
    padding: 0.9rem;
    font-size: 2rem;
    color: $cAddNeutral;
    cursor: pointer;
    transition: color $tr;

    &--list {
      font-size: 1.8rem;
    }

    &--showMobile {
      display: none;

      @include rwd('small-tablet') {
        display: block;
      }
    }

    &:hover {
      color: $cSec;

      #{$root}__iconList {
        color: $cSec;
      }
    }
  }

  &__iconList {
    color: $cAddNeutral;
    font-size: 2rem;
    position: relative;

    &:before {
      @include icomoon('heart');
    }

    &:after {
      @include icomoon('heart-full');
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
    }

    &.active {
      color: $cSec;

      &:after {
        opacity: 1;
      }
    }
  }

  &__iconListActive {
    opacity: 0;
    transition: opacity $tr;
  }
}
</style>
